import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import isNil from 'lodash/isNil';

function setControlError(control: AbstractControl | null, key: string, active: boolean): void {
  if (!control) return;

  const current = control.errors ?? {};

  if (active) {
    control.setErrors({ ...current, [key]: true });
  } else {
    const { [key]: _, ...remaining } = current;
    control.setErrors(Object.keys(remaining).length ? remaining : null);
  }
}

export function intervalRangeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const minRaw = control.get('minInterval')?.value;
    const maxRaw = control.get('maxInterval')?.value;
    const min = !isNil(minRaw) && minRaw !== '' ? Number(minRaw) : null;
    const max = !isNil(maxRaw) && maxRaw !== '' ? Number(maxRaw) : null;

    const hasError = min !== null && max !== null && min > max;

    setControlError(control.get('minInterval'), 'intervalRange', hasError);
    setControlError(control.get('maxInterval'), 'intervalRange', hasError);

    return null;
  };
}
